import React from "react";
import "./card2.css";
import { useHistory } from "react-router-dom";

import { connect } from "react-redux";
import { getCampaignImageUrl } from "../../config";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";

function MediaCard2(props) {


  const formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };

  const history = useHistory();

  const onNameClick = row => {
  
    props.onHandleCampaign(row);
    localStorage.setItem("path", "/campaigns");

    history.push({ pathname: "/campaigns", state: row });

  };



  const rows = props.DashboardData.newRecentdata;

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow></TableRow>
        </TableHead>
        <TableBody>
          <div class="Recent_performance">
            <tr class="MuiTableRow-root first-row">
              <th class="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                Campaigns
              </th>
              <td class="MuiTableCell-root MuiTableCell-body MuiTableCell-alignRight MuiTableCell-sizeSmall">
                Invitation
              </td>
              <td class="MuiTableCell-root MuiTableCell-body MuiTableCell-alignRight MuiTableCell-sizeSmall">
                Connections
              </td>
              <td class="MuiTableCell-root MuiTableCell-body MuiTableCell-alignRight MuiTableCell-sizeSmall">
                Engagement
              </td>
              <td class="MuiTableCell-root MuiTableCell-body MuiTableCell-alignRight MuiTableCell-sizeSmall">
                Leads
              </td>
              <td class="MuiTableCell-root MuiTableCell-body MuiTableCell-alignRight MuiTableCell-sizeSmall">
                Start Date
              </td>
            </tr>
            {rows.map(row => (
              <TableRow
                key={row.company}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  onClick={() => onNameClick(row)}
                >
                  <div className="infoData">
                    <div className="campaignName">
                      {" "}
                      {row.campaignLogo != null && (
                        <img src={getCampaignImageUrl.url + row.campaignLogo} />
                      )}
                      {row.campaignLogo == null && (
                        <div> {row.campaignName.charAt(0).toUpperCase()} </div>
                      )}
                    </div>
                    <div className="campaign-detail">
                  
                      <h3>{row.campaignName} </h3>
                      <p>for {row.company}</p>
                      <p>Profile {row.Linkedin}</p>
                    </div>
                  </div>
         
                </TableCell>

                <TableCell align="right">
                  <strong>{row.invitedContact}</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>
                    {row.connectedPer
                      ? row.connectedPer.toFixed(0) + "%"
                      : 0 + "%"}
                  </strong>
                </TableCell>

                <TableCell align="right">
                  <strong>
                    {row.engagedPer ? row.engagedPer.toFixed(0) + "%" : 0 + "%"}
                  </strong>
                </TableCell>
                <TableCell align="right">
                  <strong>
                    {row.leadPer ? row.leadPer.toFixed(0) + "%" : 0 + "%"}
                  </strong>
                </TableCell>

                <TableCell align="right">{formatDate(row.startdate)}</TableCell>
              </TableRow>
            ))}
          </div>
        </TableBody>
      </Table>
    </TableContainer>
  );
 

  function onClickCard(currentHeader) {
    props.onClickCard(currentHeader);
  }


}
const mapDispatchToProps = dispatch => {
 
  return {
    onHandleCampaign: data =>
      dispatch({
        type: "Campaign_Detail",
        payload: data
      })
  };
};

export default connect(null, mapDispatchToProps)(MediaCard2);

